export enum BusinessType {
  Ecommerce = 'ECOMMERCE',
  Physical = 'PHYSICAL',
}
